import { render, staticRenderFns } from "./ItemSlot.vue?vue&type=template&id=0dc8b142&"
import script from "./ItemSlot.vue?vue&type=script&lang=js&"
export * from "./ItemSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports